import { type FC } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";

import { formatAxisLabel, getAxisTickIndexes } from "./chartAxis";
import * as Styled from "./ChartXAxis.styles";
import { ChartXAxisSkeleton } from "./ChartXAxisSkeleton";

export const ChartXAxis: FC = () => {
  const { timeline, isChanceHistoryLoading, range, settings } = useCoreChart();

  if (isChanceHistoryLoading) {
    return <ChartXAxisSkeleton />;
  }

  if (!settings.xAxis || !timeline.length) {
    return <Styled.Root />;
  }

  return (
    <Styled.Root>
      {getAxisTickIndexes(timeline.length).map((pointIndex) => {
        const timestamp = timeline[pointIndex];

        return (
          <Styled.Tick key={timestamp}>
            {formatAxisLabel(timestamp, range)}
          </Styled.Tick>
        );
      })}
    </Styled.Root>
  );
};
